"use client";

import {
  type BusinessVariables,
  BusinessVariablesProvider,
} from "@grupa-pracuj/business-variables";
import { GatewayProvider } from "@grupa-pracuj/gateway-library-sip";
import { CurrentDeviceProvider } from "@grupa-pracuj/ui-library-sip";
import { TrackerProvider } from "@/tracker";
import type { User } from "@/types";

export const Providers = ({
  children,
  gateway,
  appName,
  appVersion,
  businessVariables,
  environment,
  user,
  userAgent,
}: {
  children: React.ReactNode;
  gateway: string;
  appName: string;
  appVersion: string;
  businessVariables: BusinessVariables;
  environment: string;
  user?: User | null;
  userAgent?: string;
}) => {
  return (
    <CurrentDeviceProvider userAgent={userAgent}>
      <GatewayProvider
        gateway={gateway}
        appName={appName}
        appVersion={appVersion}
      >
        <BusinessVariablesProvider variables={businessVariables}>
          <TrackerProvider
            environment={environment}
            appName={appName}
            appVersion={appVersion}
            user={user}
          >
            {children}
          </TrackerProvider>
        </BusinessVariablesProvider>
      </GatewayProvider>
    </CurrentDeviceProvider>
  );
};

export default Providers;
